import { CatHeading } from '@blocks-react/components/Heading';
import { CatIconEmail } from '@blocks-react/components/Icons/Email';
import { CatIconHyperlink } from '@blocks-react/components/Icons/Hyperlink';
import { CatIconLocation } from '@blocks-react/components/Icons/Location';
import { CatIconPhone } from '@blocks-react/components/Icons/Phone';
import { Conditional } from '../conditional';
import { LinkWithIcon } from '../link-with-icon';
import { StoreContactInfoProps } from './types';
import { getDrivingDirections, getWebsiteUri } from './utils';

export const StoreContactInfo = ({
  title,
  phone,
  phoneNumberLabel,
  email,
  emailLabel,
  emailTarget = '_blank',
  contactUrl = '',
  website = '',
  websiteLabel,
  latitude = '',
  longitude = '',
  drivingDirectionsLabel,
  linkClassName,
  linkTextClassName
}: StoreContactInfoProps) => {
  const drivingDirections = getDrivingDirections(latitude, longitude);
  const showEmail = !!email && !!contactUrl;
  const showDrivingDirections = !!latitude && !!longitude;
  const showStoreContactInfo =
    !!phone || !!website || showEmail || showDrivingDirections;

  return (
    <Conditional test={showStoreContactInfo}>
      <CatHeading level="h2" variant="title-sm">
        {title}
      </CatHeading>
      <Conditional test={!!phone}>
        <LinkWithIcon
          linkClassName={linkClassName}
          linkTextClassName={linkTextClassName}
          href={`tel:${phone}`}
          icon={<CatIconPhone />}
          aria-label={`${phoneNumberLabel}${phone}`}
        >
          {phone}
        </LinkWithIcon>
      </Conditional>
      <Conditional test={showEmail}>
        <LinkWithIcon
          linkClassName={linkClassName}
          linkTextClassName={linkTextClassName}
          href={contactUrl}
          target={emailTarget}
          icon={<CatIconEmail />}
          aria-label={`${emailLabel}${contactUrl}`}
        >
          {emailLabel}
        </LinkWithIcon>
      </Conditional>
      <Conditional test={!!website}>
        <LinkWithIcon
          linkClassName={linkClassName}
          linkTextClassName={linkTextClassName}
          href={getWebsiteUri(website)}
          target="_blank"
          icon={<CatIconHyperlink />}
          aria-label={`${websiteLabel}${website}`}
        >
          {websiteLabel}
        </LinkWithIcon>
      </Conditional>
      <Conditional test={showDrivingDirections}>
        <LinkWithIcon
          linkClassName={linkClassName}
          linkTextClassName={linkTextClassName}
          href={drivingDirections}
          target="_blank"
          icon={<CatIconLocation />}
          aria-label={`${drivingDirectionsLabel}${drivingDirections}`}
        >
          {drivingDirectionsLabel}
        </LinkWithIcon>
      </Conditional>
    </Conditional>
  );
};
